<template>
  <div class="column items-end">
    <q-btn
      v-if="useLoginPage"
      @click="handleSignOut"
      unelevated
      no-caps
      label="Sign Out"
      class="text-bold"
      color="signout"
    />
  </div>
</template>

<script>
import { watchEffect } from "vue";
import FirebaseService from "../service/FirebaseService.js";
import NotificationHelper from '../helper/NotificationHelper.js';
import EmailService from "../service/EmailService.js";

export default {
  name: "SignOutButton",
  setup() {
    const useLoginPage = process.env.VUE_APP_USE_LOGIN_PAGE === "true";

    const { user } = FirebaseService.getUser();

    watchEffect(() => {
      if (!user.value && useLoginPage) {
        window.location.reload();
      }
    });

    async function handleSignOut() {
      try {
        localStorage.removeItem("currentLoggedInUserUid");

        await FirebaseService.firebaseSignOut();
      } catch (error) {
        EmailService.sendErrorEmail("SignOutButton.vue - handleSignOut", error);
        NotificationHelper.createErrorNotification("Error encountered. Please try again.");
      }
    }
    return {
      //variable properties
      useLoginPage,

      //functions
      handleSignOut
    };
  }
};
</script>

<style scoped>
.bg-signout {
  background: #707070 !important;
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  z-index: var(--sign-out-button-z-index);
}
</style>